module.exports = __webpack_public_path__ + "static/media/IIIMostra_Banners.be3452cb.pptx";